import { customElement } from "lit/decorators.js";

import { NavigationMenuElement } from "./bible-navigation-menu";
import { ariaBoolean } from "..";

@customElement("bible-navigation")
export class NavigationElement extends HTMLElement {
  private $queryButton = document.querySelector(
    "bible-navigation-query-button",
  )!;

  private $translationButton = document.querySelector(
    "bible-navigation-translation-button",
  )!;

  private timeout: number | undefined;

  private close() {
    this.$queryButton.isExpanded = false;
    this.$translationButton.isExpanded = false;
    this.setIsExpandedAttribute();
  }

  connectedCallback() {
    this.addEventListener("focusout", this.onFocusOut, { passive: true });
    this.$queryButton.addEventListener("focusout", this.onFocusOut);
    this.$queryButton.addEventListener("open", this.onQueryButtonOpen);
    this.$translationButton.addEventListener(
      "open",
      this.onTranslationButtonOpen,
    );
    document.body.addEventListener("click", this.onBodyClick, {
      capture: true,
      passive: true,
    });
  }

  disconnectedCallback() {
    this.removeEventListener("focusout", this.onFocusOut);
    this.$queryButton.removeEventListener("open", this.onQueryButtonOpen);
    this.$translationButton.removeEventListener(
      "open",
      this.onTranslationButtonOpen,
    );
    document.body.removeEventListener("click", this.onBodyClick);
  }

  private onBodyClick = (e: MouseEvent) => {
    const path = e.composedPath() as HTMLElement[];
    window.clearTimeout(this.timeout);
    this.timeout = window.setTimeout(() => {
      const [target] = path;
      const $page = document.querySelector(`.Page`)!;
      if (
        target instanceof HTMLButtonElement ||
        target instanceof HTMLInputElement ||
        $page.hasAttribute("inert")
      ) {
        return;
      }
      const $menu = path.find((e) => e instanceof NavigationMenuElement);
      if ($menu?.contains(target)) return;
      this.close();
    });
  };

  private onFocusOut = () => {
    // This method gets called multiple times in certain cases becuase both
    // <bible-navigation> and <bible-navigation-query-button> trigger focusout events
    window.clearTimeout(this.timeout);
    this.timeout = window.setTimeout(() => {
      const $page = document.querySelector(`.Page`)!;
      if ($page.hasAttribute("inert")) return;
      if (document.activeElement !== this.$queryButton) {
        this.$queryButton.isExpanded = false;
      }
      if (document.activeElement !== this.$translationButton) {
        this.$translationButton.isExpanded = false;
      }
      this.setIsExpandedAttribute();
    }, 100);
  };

  private onQueryButtonOpen = () => {
    this.$translationButton.isExpanded = false;
    this.setIsExpandedAttribute();
  };

  private onTranslationButtonOpen = () => {
    this.$queryButton.isExpanded = false;
    this.setIsExpandedAttribute();
  };

  private setIsExpandedAttribute() {
    this.setAttribute(
      "data-menu-expanded",
      ariaBoolean(
        this.$queryButton.isExpanded || this.$translationButton.isExpanded,
      ),
    );
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bible-navigation": NavigationElement;
  }
}
